<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 5.625C2 5.27982 2.27982 5 2.625 5H17.375C17.7202 5 18 5.27982 18 5.625C18 5.97018 17.7202 6.25 17.375 6.25H2.625C2.27982 6.25 2 5.97018 2 5.625ZM4.66667 9.99902C4.66667 9.65385 4.94649 9.37402 5.29167 9.37402H14.7083C15.0535 9.37402 15.3333 9.65385 15.3333 9.99902C15.3333 10.3442 15.0535 10.624 14.7083 10.624H5.29167C4.94649 10.624 4.66667 10.3442 4.66667 9.99902ZM8.8474 13.7476C8.50222 13.7476 8.2224 14.0274 8.2224 14.3726C8.2224 14.7177 8.50222 14.9976 8.8474 14.9976H11.153C11.4981 14.9976 11.778 14.7177 11.778 14.3726C11.778 14.0274 11.4981 13.7476 11.153 13.7476H8.8474Z" />
</template>
